module.exports = {
        srcSet: __webpack_public_path__ + "app_stores_banner_google_KM-646-7dbf5800affb0d75.digested.png"+" 646w",
        images: [{path: __webpack_public_path__ + "app_stores_banner_google_KM-646-7dbf5800affb0d75.digested.png",width: 646,height: 250}],
        src: __webpack_public_path__ + "app_stores_banner_google_KM-646-7dbf5800affb0d75.digested.png",
        toString: function(){return __webpack_public_path__ + "app_stores_banner_google_KM-646-7dbf5800affb0d75.digested.png"},
        
        width: 646,
        height: 250
      }